import React, { useState } from 'react'
import { styled } from "@mui/material/styles";
import { Avatar, InputAdornment, TextField } from '@mui/material';
import palette from "src/theme/palette";


const CustomTextField = styled(TextField)(() => ({
    "& .MuiOutlinedInput-root": {
      backgroundColor: palette.light.common.white,
      fontSize: "12px",
      color: palette.light.common.black,
      height: 40,
      borderRadius: 4,
      "&.Mui-focused fieldset": {
        borderColor: palette.light.common.black,
        borderWidth:"thin"
      },
    },
  }));

const SearchBox= ({onChange=()=>{}, searchNow=()=>{}, placeholderCTA=''}) => {
    const [searchText,setSearchText] = useState("");
    const handleOnChange=(e)=>{
        setSearchText(e.target.value);
        onChange(e.target.value);
    };
    
    const onClear=()=>{
        setSearchText("");
        onChange("");
    }
    return (
        <div>
        <CustomTextField
            onChange={handleOnChange}
            onKeyPress={(e) => {
                if (e.key === "Enter") {
                  searchNow(searchText);
                }
              }}
            value={searchText}
            placeholder={
                placeholderCTA ? placeholderCTA :"Search project"
            }
            sx={{width:"100%"}}
            InputProps={{
                startAdornment: (
                <InputAdornment position="start">
                    <Avatar
                    alt=""
                    src="/icons/carbon-search.svg"
                    sx={{ width: 20, height: 20 }}
                    />
                </InputAdornment>
                ),
                endAdornment: (
                <InputAdornment position="end">
                    {searchText && (
                    <Avatar
                        onClick={onClear}
                        alt=""
                        src="/icons/close.svg"
                        sx={{ width: 20, height: 20,cursor:"pointer" }}
                    />
                    )}
                </InputAdornment>
                ),
            }}
            />
        </div>
    )
}

export default SearchBox

